import * as RadixSelect from '@radix-ui/react-select';
import { forwardRef, type ReactNode } from 'react';

import { Check } from '@air/next-icons';
import { tailwindVariants, type VariantProps } from '@air/utils-tailwind';

export const selectItem = tailwindVariants({
  base: 'group/select-item flex shrink-0 cursor-pointer items-center rounded-4 px-1.5 text-inherit outline-none radix-disabled:cursor-not-allowed radix-disabled:bg-transparent radix-disabled:opacity-50 radix-highlighted:bg-grey-4 hover:bg-grey-4 disabled:cursor-not-allowed gap-1',
  defaultVariants: {
    size: 'small',
  },
  variants: {
    size: {
      large: 'min-h-[36px] text-16',
      small: 'min-h-[32px] text-14',
    },
  },
});

export type SelectItemVariants = VariantProps<typeof selectItem>;

export type SelectItemProps = Omit<RadixSelect.SelectItemProps, 'prefix'> &
  SelectItemVariants & {
    prefix?: ReactNode;
  };

export const SelectItem = forwardRef<HTMLDivElement, SelectItemProps>(
  ({ children, className, prefix, size, ...restOfProps }, forwardedRef) => {
    return (
      <RadixSelect.Item
        className={selectItem({ class: className, size })}
        data-testid="SELECT_ITEM"
        {...restOfProps}
        ref={forwardedRef}
      >
        {prefix ? <div className="flex shrink-0 items-center justify-center">{prefix}</div> : null}

        <span className="grow">
          <RadixSelect.ItemText>{children}</RadixSelect.ItemText>
        </span>

        <RadixSelect.ItemIndicator className="shrink-0">
          <Check className="size-4 text-blue-9" />
        </RadixSelect.ItemIndicator>
      </RadixSelect.Item>
    );
  },
);

SelectItem.displayName = 'SelectItem';
